import { getURLParameter } from 'utils';

/**
 * App Configuration based on env && __DEV__
 */
const versionNumber = 1;
const projectName = 'postpe';

const config = {
	stage: {
		handshake: 'https://api-merchant.bharatpe.io/merchant/v1/',
		postpe: 'https://api-postpe.bharatpe.io/postpe/',
		card: 'https://api-card.bharatpe.io/postpe/',
		postpeV1: 'https://api-postpe.bharatpe.io/postpe/v1/',
		payment: 'https://api-postpe.bharatpe.io/postpe/payment/',
		paymentV2: 'https://api-postpe.bharatpe.io/postpe/payment/v2/',
		paymentV3: 'https://api-postpe.bharatpe.io/postpe/payment/v3/',
		consumer: 'https://api-consumer.bharatpe.io/customer/',
		consumerV2: 'https://api-consumer.bharatpe.io/v2/customer/',
		loans: 'https://api-postpe.bharatpe.io/dsa/v1/loans',
		billPayment: 'https://bill-paymentservice.bharatpe.io/bill-payment/',
		mock: 'https://demo6198732.mockable.io/',
		jarvis: 'https://postpe-jarvis.bharatpe.io/',
		userDataService: 'https://user-data-service.bharatpe.io/',
		dsa: 'https://api-postpe.bharatpe.io/dsa/v1/',
		script: 'https://api-postpe.bharatpe.io/script/',
		versionNumber: versionNumber,
		projectName: projectName,
	},
	qa: {
		handshake: 'https://api-merchant.bharatpe.co.in/merchant/v1/',
		postpe: 'https://api-postpe.bharatpe.co.in/postpe/',
		card: 'https://api-card.bharatpe.co.in/postpe/',
		postpeV1: 'https://api-postpe.bharatpe.co.in/postpe/v1/',
		payment: 'https://api-postpe.bharatpe.co.in/postpe/payment/',
		paymentV2: 'https://api-postpe.bharatpe.co.in/postpe/payment/v2/',
		consumer: 'https://api-consumer-qa.bharatpe.co.in/customer/',
		loans: 'https://api-postpe.bharatpe.co.in/dsa/v1/loans',
		billPayment: 'https://bill-paymentservice.bharatpe.co.in/bill-payment/',
		mock: 'https://demo6198732.mockable.co.in/',
		jarvis: 'https://postpe-jarvis-qa.bharatpe.co.in/',
		userDataService: 'https://user-data-service-qa.bharatpe.co.in/',
		dsa: 'https://api-postpe.bharatpe.co.in/dsa/v1/',
		script: 'https://api-postpe.bharatpe.co.in/script/',
		versionNumber: versionNumber,
		projectName: projectName,
	},
	uat: {
		handshake: 'https://api-merchant.bharatpe.io/merchant/v1/',
		postpe: 'https://api-preprod-postpe.bharatpe.in/postpe/',
		card: 'https://api-card-uat.bharatpe.in/postpe/',
		script: 'https://api-preprod-postpe.bharatpe.in/script/',
		postpeV1: 'https://api-preprod-postpe.bharatpe.in/postpe/v1/',
		paymentV3: 'https://api-postpe.bharatpe.in/postpe/payment/v3/',
		payment: 'https://api-preprod-postpe.bharatpe.in/postpe/payment/',
		paymentV2: 'https://api-preprod-postpe.bharatpe.in/postpe/payment/v2/',
		consumerV2: 'https://api-consumer-pp.bharatpe.in/v2/customer/',
		consumer: 'https://api-consumer-pp.bharatpe.in/customer/',
		loans: 'https://api-preprod-postpe.bharatpe.in/dsa/v1/loans',
		billPayment: 'https://bill-paymentservice-pp.bharatpe.in/bill-payment/',
		mock: 'https://demo6198732.mockable.io/',
		jarvis: 'https://postpe-jarvis-uat.bharatpe.in/',
		userDataService: 'https://user-data-service.bharatpe.in/',
		dsa: 'https://api-preprod-postpe.bharatpe.in/dsa/v1/',
		versionNumber: versionNumber,
		projectName: projectName,
	},
	uat1: {
		handshake: 'https://api-merchant.bharatpe.io/merchant/v1/',
		postpe: 'https://api-postpe-uat1.bharatpe.in/postpe/',
		script: 'https://api-postpe-uat1.bharatpe.in/script/',
		card: 'https://api-card-uat2.bharatpe.in/postpe/',
		postpeV1: 'https://api-postpe-uat1.bharatpe.in/postpe/v1/',
		payment: 'https://api-postpe-uat1.bharatpe.in/postpe/payment/',
		paymentV2: 'https://api-postpe-uat1.bharatpe.in/postpe/payment/v2/',
		paymentV3: 'https://api-postpe-uat1.bharatpe.in/postpe/payment/v3/',
		consumer: 'https://api-consumer-pp.bharatpe.in/customer/',
		consumerV2: 'https://api-consumer.bharatpe.in/v2/customer/',
		loans: 'https://api-postpe-uat1.bharatpe.in/dsa/v1/loans',
		billPayment: 'https://bill-paymentservice-pp.bharatpe.in/bill-payment/',
		mock: 'https://demo6198732.mockable.io/',
		jarvis: 'https://postpe-jarvis-uat.bharatpe.in',
		userDataService: 'https://user-data-service.bharatpe.in/',
		dsa: 'https://api-postpe-uat1.bharatpe.in/dsa/v1/',
		versionNumber: versionNumber,
		projectName: projectName,
	},
	uat2: {
		handshake: 'https://api-merchant.bharatpe.io/merchant/v1/',
		postpe: 'https://api-postpe-uat2.bharatpe.in/postpe/',
		card: 'https://api-card-uat2.bharatpe.in/postpe/',
		postpeV1: 'https://api-postpe-uat2.bharatpe.in/postpe/v1/',
		script: 'https://api-postpe-uat2.bharatpe.in/script/',
		postpeV2: 'https://api-postpe-uat2.bharatpe.in/postpe/v2/',
		paymentV3: 'https://api-postpe-uat2.bharatpe.in/postpe/payment/v3/',
		payment: 'https://api-postpe-uat2.bharatpe.in/postpe/payment/',
		paymentV2: 'https://api-postpe-uat2.bharatpe.in/postpe/payment/v2/',
		consumerV2: 'https://api-consumer.bharatpe.in/v2/customer/',
		consumer: 'https://api-consumer-uat2.bharatpe.in/customer/',
		loans: 'https://api-postpe-uat2.bharatpe.in/dsa/v1/loans',
		billPayment: 'https://bill-paymentservice-pp.bharatpe.in/bill-payment/',
		mock: 'https://demo6198732.mockable.io/',
		jarvis: 'https://postpe-jarvis-uat.bharatpe.in',
		userDataService: 'https://user-data-service.bharatpe.in/',
		dsa: 'https://api-postpe-uat2.bharatpe.in/dsa/v1/',
		versionNumber: versionNumber,
		projectName: projectName,
	},
	uat3: {
		handshake: 'https://api-merchant.bharatpe.io/merchant/v1/',
		postpe: 'https://api-postpe-uat3.bharatpe.in/postpe/',
		script: 'https://api-postpe-uat3.bharatpe.in/script/',
		card: 'https://api-card-uat2.bharatpe.in/postpe/',
		postpeV1: 'https://api-postpe-uat3.bharatpe.in/postpe/v1/',
		payment: 'https://api-postpe-uat3.bharatpe.in/postpe/payment/',
		paymentV2: 'https://api-postpe-uat3.bharatpe.in/postpe/payment/v2/',
		paymentV3: 'https://api-postpe-uat3.bharatpe.in/postpe/payment/v3/',
		consumer: 'https://api-consumer.bharatpe.in/customer/',
		consumerV2: 'https://api-consumer.bharatpe.in/v2/customer/',
		loans: 'https://api-postpe-uat3.bharatpe.in/dsa/v1/loans',
		billPayment: 'https://bill-paymentservice-uat3.bharatpe.in/bill-payment/',
		mock: 'https://demo6198732.mockable.io/',
		jarvis: 'https://postpe-jarvis-uat.bharatpe.in',
		userDataService: 'https://user-data-service.bharatpe.in/',
		dsa: 'https://api-postpe-uat3.bharatpe.in/dsa/v1/',
		versionNumber: versionNumber,
		projectName: projectName,
	},
	uat4: {
		handshake: 'https://api-merchant.bharatpe.io/merchant/v1/',
		postpe: 'https://api-postpe-uat4.bharatpe.in/postpe/',
		card: 'https://api-card-uat2.bharatpe.in/postpe/',
		postpeV1: 'https://api-postpe-uat4.bharatpe.in/postpe/v1/',
		script: 'https://api-postpe-uat4.bharatpe.in/script/',
		payment: 'https://api-postpe-uat4.bharatpe.in/postpe/payment/',
		paymentV2: 'https://api-postpe-uat4.bharatpe.in/postpe/payment/v2/',
		paymentV3: 'https://api-postpe-uat4.bharatpe.in/postpe/payment/v3/',
		consumer: 'https://api-consumer.bharatpe.in/customer/',
		consumerV2: 'https://api-consumer.bharatpe.in/v2/customer/',
		loans: 'https://api-postpe-uat4.bharatpe.in/dsa/v1/loans',
		billPayment: 'https://bill-paymentservice-uat2.bharatpe.in/bill-payment/',
		mock: 'https://demo6198732.mockable.io/',
		jarvis: 'https://postpe-jarvis-uat.bharatpe.in',
		userDataService: 'https://user-data-service.bharatpe.in/',
		dsa: 'https://api-postpe-uat4.bharatpe.in/dsa/v1/',
		versionNumber: versionNumber,
		projectName: projectName,
	},
	env: process.env.NODE_ENV || 'stage',
	production: {
		handshake: 'https://api-merchant.bharatpe.in/merchant/v1/',
		postpe: 'https://api-postpe.bharatpe.in/postpe/',
		script: 'https://api-postpe.bharatpe.in/script/',
		card: 'https://api-card.bharatpe.in/postpe/',
		postpeV1: 'https://api-postpe.bharatpe.in/postpe/v1/',
		postpeV2: 'https://api-postpe.bharatpe.in/postpe/v2/',
		payment: 'https://api-postpe.bharatpe.in/postpe/payment/',
		paymentV2: 'https://api-postpe.bharatpe.in/postpe/payment/v3/',
		paymentV3: 'https://api-postpe.bharatpe.in/postpe/payment/v3/',
		consumer: 'https://api-consumer.bharatpe.in/customer/',
		consumerV2: 'https://api-consumer.bharatpe.in/v2/customer/',
		loans: 'https://api-postpe.bharatpe.in/dsa/v1/loans',
		billPayment: 'https://bill-paymentservice.bharatpe.in/bill-payment/',
		mock: 'https://demo6198732.mockable.io/',
		jarvis: 'https://postpe-jarvis.bharatpe.in/',
		userDataService: 'https://user-data-service.bharatpe.in/',
		dsa: 'https://api-postpe.bharatpe.in/dsa/v1/',
		versionNumber: versionNumber,
		projectName: projectName,
	},
	qa3: {
	  postpe: 'https://api-post-pe-qa.bharatpe.co.in/postpe/',
	  postpeV1: 'https://api-post-pe-qa.bharatpe.co.in/postpe/v1/',
	  postpeV2: 'https://api-post-pe-qa.bharatpe.co.in/postpe/v2/',
	  consumer: 'https://api-consumer.bharatpe.in/customer/',
	  loans: 'https://api-post-pe-qa.bharatpe.co.in/dsa/',
	  consumerV2: 'https://api-consumer.bharatpe.in/v2/customer/',
	  mock: 'https://demo6198732.mockable.io/',
	  jarvis: 'https://postpe-jarvis-uat.bharatpe.in',
	  dsa: 'https://api-post-pe-qa.bharatpe.co.in/dsa/v1/',
	  handshake: 'https://api-merchant.bharatpe.io/merchant/v1/',
	  versionNumber: versionNumber,
	  projectName: projectName,
	  card: 'https://api-card.bharatpe.io/postpe/',
	  payment: 'https://api-postpe.bharatpe.io/postpe/payment/',
	  paymentV2: 'https://api-postpe.bharatpe.io/postpe/payment/v2/',
	  paymentV3: 'https://api-postpe.bharatpe.io/postpe/payment/v3/',
	  userDataService: 'https://user-data-service.bharatpe.io/',
	  script: 'https://api-postpe.bharatpe.io/script/',
	},
};

let configs = config[getURLParameter('beEnv')] || config.production;
export default configs;
